import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { UpdateManagerNotesService } from './update-manager-notes.service';
import { IUPPTasksMap } from '../../models/task-unplannedpickup';
import { takeLast } from 'rxjs/operators';
 
@Component({
    selector: 'app-update-manager-notes',
    templateUrl: './update-manager-notes.component.html',
    styleUrls: ['./update-manager-notes.component.scss'],
    standalone: false
})
export class UpdateManagerNotesComponent implements OnChanges {
  @Input() task: IUPPTasksMap;
  @Output() closeDialog = new EventEmitter<any>();
 
  managerNote: string = '';
 
  @ViewChild('managerNotesFooter', {static:true}) managerNotesFooter!: TemplateRef<any> 
  constructor(private readonly updateManagerNotesService: UpdateManagerNotesService) {}
 
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['task']) {
      this.managerNote = '';
    }
  }
 
  cancel(): void {
    this.closeDialog.emit(true);
  }
 
  submitNote(): void {
    const note = this.managerNote.trim();
    if (!note) return;
 
    this.task.manager_instruction = note;
    this.updateManagerNotesService.formManagerNoteObject(this.task);
 
    this.updateManagerNotesService.submitManagerNote().pipe(takeLast(1)).subscribe(success => {
      if (success) {
        this.closeDialog.emit(true);
      }
    });
  }
}